import { TextSkeleton } from '@/components/Skeleton';
import { getScoreIcon } from '@/components/TokenProfile/TokenLiquidityScore/getScoreIcon';

import { useLiquidityScore } from '@/hooks/useLiquidityScore';

import { fontStyles } from '@/styles/typography';

import type { TokenResult } from '@/utils/0x/token-registry.types';

const SkeletonPill = () => <TextSkeleton width={90} height={32} lineClassName="rounded-2xl" />;

export const LiquidityScore = ({ token }: { token: TokenResult | undefined }) => {
  const { data, isLoading } = useLiquidityScore(
    token ? [{ address: token.address, chainId: token.chainId }] : undefined,
  );

  if (isLoading || !token) return <SkeletonPill />;

  const score = token?.tokenListsBlock?.length === 0 ? data?.data?.[0]?.score : undefined;
  const icon = getScoreIcon(score);

  return (
    <div
      className={fontStyles({
        variant: 'LABEL_SM',
        class: [
          'items-center',
          'rounded-xl',
          'flex',
          'justify-center',
          'h-8',
          'px-3',
          'gap-1.5',
          'min-w-[87.5px]',
          'w-fit',
          'outline-none',
          'pointer-events-none',
          'bg-token-alphalight-300',
          'hover:bg-token-alphalight-400',
          'active:bg-token-alphalight-400',
          'focus-visible:outline-token-alphalight-500',
          'focus-visible:outline-2',
          'focus-visible:outline-solid',
        ],
      })}
      style={{ flexGrow: 1, padding: '0' }}
    >
      {icon}

      <span className="flex items-center ml-1 text-body-sm">
        {Number.isFinite(score) ? `${score}/10` : '-'}
      </span>
    </div>
  );
};
